import { create, StateCreator } from 'zustand'
import { ISparkVideosUrls } from '@components/MediaRender'
export interface IVideoDefaultProps {
  mediaUrl: string
  videoUrl: ISparkVideosUrls
  title: string
  thumbnailUrl: string
  timeToResume: number | null
  isVideoEnded: boolean
  isLandscape: boolean
}

interface IFullScreenModeState {
  isFullScreenMode: boolean
  setIsFullScreenMode: (isFullScreenMode: boolean) => void
  videoDefaultProps: IVideoDefaultProps
  setVideoDefaultProps: (videoDefaultProps: IVideoDefaultProps) => void
}

const createFullScreenModeStore: StateCreator<IFullScreenModeState> = (
  set,
) => ({
  isFullScreenMode: false,
  setIsFullScreenMode: (isFullScreenMode: boolean) => set({ isFullScreenMode }),
  videoDefaultProps: {
    mediaUrl: '',
    videoUrl: {
      mainUrl: '',
      qualities: [],
      thumbnailUrl: '',
      isLandscape: false,
    },
    title: '',
    thumbnailUrl: '',
    timeToResume: null,
    isVideoEnded: false,
    isLandscape: false,
  },
  setVideoDefaultProps: (videoDefaultProps: IVideoDefaultProps) =>
    set({ videoDefaultProps }),
})

export const useFullScreenModeStore = create<IFullScreenModeState>(
  createFullScreenModeStore,
)
